import React, { useEffect, useState } from "react";
import { Container, Table, Button, Form, Row, Col } from "react-bootstrap";
import Factura from "./Factura";
import API_BASE from "../api"; // ✅ Importamos la URL base

function ListarFacturas() {
  const [facturas, setFacturas] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/facturas`) // ✅ Usamos la URL base aquí
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setFacturas(data);
        else console.error("Respuesta inesperada:", data);
      })
      .catch((error) => console.error("Error al obtener facturas:", error));
  }, []);

  const filtrar = facturas.filter((f) => {
    const texto = busqueda.toLowerCase();
    return (
      f.cliente.toLowerCase().includes(texto) ||
      f.numeroFactura?.toString().includes(texto) ||
      f.total?.toString().includes(texto) ||
      new Date(f.fecha).toLocaleDateString("es-CL").includes(texto)
    );
  });

  const handlePrint = () => {
    const contenido = document.getElementById("factura-imprimir").innerHTML;
    const ventana = window.open("", "_blank", "width=800,height=600");

    ventana.document.write(`
      <html>
        <head>
          <title>Factura</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 40px; }
            table { width: 100%; border-collapse: collapse; }
            td, th { border: 1px solid #000; padding: 6px; text-align: center; }
            h2, h4 { text-align: center; }
            img { width: 80px; height: auto; margin-right: 15px; }
          </style>
        </head>
        <body>${contenido}</body>
      </html>
    `);

    ventana.document.close();

    ventana.onload = () => {
      const logo = ventana.document.querySelector("img");
      if (logo && !logo.complete) {
        logo.onload = () => {
          ventana.print();
          ventana.close();
        };
      } else {
        ventana.print();
        ventana.close();
      }
    };
  };

  return (
    <Container style={{ maxWidth: 1000, padding: 20 }}>
      <h3 className="mb-4 text-center">📁 Facturas Guardadas</h3>

      {/* Búsqueda */}
      <Form className="mb-4">
        <Row>
          <Col md={6} className="mx-auto">
            <Form.Control
              type="text"
              placeholder="🔍 Buscar por cliente, fecha, número o total..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
          </Col>
        </Row>
      </Form>

      {/* Tabla */}
      {filtrar.length === 0 ? (
        <p className="text-center">No hay facturas encontradas.</p>
      ) : (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Fecha</th>
              <th>N° Factura</th>
              <th>Cliente</th>
              <th>Total</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {filtrar.map((f, idx) => (
              <tr key={idx}>
                <td>{new Date(f.fecha).toLocaleDateString("es-CL")}</td>
                <td>{f.numeroFactura}</td>
                <td>{f.cliente}</td>
                <td>${f.total.toLocaleString("es-CL")}</td>
                <td>
                  <Button size="sm" variant="info" onClick={() => setFacturaSeleccionada(f)}>
                    Ver
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* Detalle Factura */}
      {facturaSeleccionada && (
        <div className="mt-5" id="factura-detalle">
          <div className="d-flex justify-content-between align-items-center mb-3 no-print">
            <h4>🧾 Detalle de la Factura</h4>
            <Button variant="secondary" onClick={() => setFacturaSeleccionada(null)}>Cerrar</Button>
          </div>

          <div id="factura-imprimir">
            <Factura datos={facturaSeleccionada} />
          </div>

          <div className="text-center mt-4 no-print">
            <Button variant="success" onClick={handlePrint}>🖨️ Imprimir</Button>
          </div>
        </div>
      )}
    </Container>
  );
}

export default ListarFacturas;
